import { z } from "zod";

/**
 * Shared DTO cho POST /v1/auth/refresh (US-E13.F1 · @UC0002 — refresh session).
 * Một nguồn sự thật cho api (validate biên) và mobile (auth_refresher gọi + map),
 * tránh drift (DRY). C5: schema validate tại biên tái dùng được.
 *
 * Client gửi refresh token thô (opaque). Server tra HASH trong AuthSession, rotate
 * (cấp cặp mới + revoke cũ), trả cặp token mới. Refresh token cũ dùng lại → 401.
 */
export const refreshRequestSchema = z.object({
  refreshToken: z.string().min(1),
});

export type RefreshRequest = z.infer<typeof refreshRequestSchema>;

/**
 * Response thành công của refresh — CÙNG shape token với verify/login mà mobile
 * đọc: `token` (access JWT) + `refreshToken` (mới, đã rotate). C3: KHÔNG chứa
 * secret/hash. Mobile (auth_refresher.dart) đọc đúng 2 field này.
 */
export interface RefreshResponse {
  token: string;
  refreshToken: string;
}

/** Refresh token không hợp lệ/hết hạn/đã dùng → 401 (buộc đăng nhập lại). */
export const REFRESH_INVALID_MESSAGE = "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.";
export const REFRESH_INVALID_CODE = "REFRESH_INVALID";
